module.exports = __webpack_public_path__ + "img/bf614b8032ada3841eea5bf41b78404b.jpg";